import React from 'react';
import Chip from '@mui/material/Chip';
import { DoorCrewSeat } from './types';

interface DropoffAssignedChipProps {
  seat: DoorCrewSeat;
}

export default function DropoffAssignedChip({ seat }: DropoffAssignedChipProps) {
  if (!seat.dropoff_lat || !seat.dropoff_lon || !seat.dropoff_address) {
    return null;
  }

  return (
    <Chip
      size="small"
      icon={<i className="fa fa-check-circle" />}
      label={seat.dropoff_address}
      title={seat.dropoff_address}
      color="success"
      variant="outlined"
      sx={{ mr: 0.5, mt: 0.25 }}
    />
  );
}
